export default {
    computed: {
        show_consultant_footer () {
            const { current_consultant } = this.house
            return Boolean(current_consultant && current_consultant.id)
        }
    }
}
